import { Component, OnInit } from '@angular/core';
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged } from "firebase/auth";
import { User } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss'],
    standalone: false
})
export class AuthenticationComponent implements OnInit {

  private auth = getAuth();
  public signedIn = false;
  public user;
  constructor(
    private _userService: UserService,
  ) { }

  ngOnInit(): void {
    onAuthStateChanged(this.auth, (u) => {
      if (u) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        this.signedIn = true
        this.user = u
        // ...
      } else {
        // User is signed out
        this.signedIn = false
      }
    });  
  }
  login() {
    signInWithPopup(this.auth, new GoogleAuthProvider()).then(
      x => {
        // if(!this._userService.exists(x.user.uid)){
        //   // insert the new user into Users collection
        //   let newUser = new User();
        //   newUser.uid = x.user.uid;
        //   newUser.displayName = x.user.displayName;
        //   newUser.email = x.user.email;
        //   this._userService.add(newUser);
        // }
      }
    )
  }
  // loginEmailAddress(email: string, password: string) {
  //   this.auth.signInWithEmailAndPassword(email, password)
  // }
  logout() {
    this.auth.signOut();
  }
  // async register(email: string, password: string) {
  //   var result = await this.auth.createUserWithEmailAndPassword(email, password);
  //   await (await this.auth.currentUser).sendEmailVerification();
  // }
}
